// @copyright  2006-2026 West Indies Software Engineering Company Limited. All rights reserved.

/*
    The words the client portal's own shell says. They are the only words on the
    screen that belong to no single page, so they carry the whole burden of
    telling the reader WHOSE portal this is and WHAT is in it.

    THE READER IS NOT AN ACCOUNTANT. "Engagement", "submission" and
    "compliance" are absent: the practice is "your accountant", the two
    destinations are named by what the client has to do with them, and nothing
    here is an identifier. The one exception is the sidebar's own title,
    "Client Portal" (user ruling, 2026-08-11) — it names the surface the way
    "Team Member Portal" names its sibling, so a reader who belongs to several
    organisations can tell which kind of place they are in.

    THE TWO DESTINATIONS ARE THE TWO THAT EXIST. Every entry in this shell opens
    a screen the client can actually read — a client is never offered a door
    that answers with somebody else's forbidden page.
*/

export default {
    '$dir': 'ltr',

    'portals.clients.shell.title': 'Client Portal',
    'portals.clients.shell.navLabel': 'Your accountant’s portal',
    'portals.clients.shell.tasks': 'Your tasks',
    'portals.clients.shell.tasksDescription': 'Documents and to-dos from your accountant',
    'portals.clients.shell.approvals': 'Returns to approve',
    'portals.clients.shell.approvalsDescription': 'Returns waiting on your decision',
};
